// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Control_Monad_Cleanup from "../Control.Monad.Cleanup/index.js";
import * as Control_Semigroupoid from "../Control.Semigroupoid/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Monoid_Extra from "../Data.Monoid.Extra/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Record_Extra2 from "../Data.Record.Extra2/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Semiring from "../Data.Semiring/index.js";
import * as Data_Set from "../Data.Set/index.js";
import * as Data_Set_Serialized from "../Data.Set.Serialized/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_String_CodePoints from "../Data.String.CodePoints/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Data_Symbol from "../Data.Symbol/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Tuple_T2 from "../Data.Tuple.T2/index.js";
import * as Data_Unfoldable from "../Data.Unfoldable/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Data_Validation_Semigroup from "../Data.Validation.Semigroup/index.js";
import * as Data_Vault from "../Data.Vault/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Ref from "../Effect.Ref/index.js";
import * as Effect_Unsafe from "../Effect.Unsafe/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Foreign_Object from "../Foreign.Object/index.js";
import * as Record from "../Record/index.js";
import * as Record_Builder from "../Record.Builder/index.js";
import * as Restaumatic_Common_Translations_Keys from "../Restaumatic.Common.Translations.Keys/index.js";
import * as Restaumatic_Form_DynamicResult from "../Restaumatic.Form.DynamicResult/index.js";
import * as Restaumatic_Form_Errors from "../Restaumatic.Form.Errors/index.js";
import * as Restaumatic_Form_Final from "../Restaumatic.Form.Final/index.js";
import * as Restaumatic_Form_Value from "../Restaumatic.Form.Value/index.js";
import * as Restaumatic_I18n from "../Restaumatic.I18n/index.js";
import * as Specular_Callback from "../Specular.Callback/index.js";
import * as Specular_ChoiceRef from "../Specular.ChoiceRef/index.js";
import * as Specular_Extra_Async from "../Specular.Extra.Async/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_FRP_Host from "../Specular.FRP.Host/index.js";
import * as Specular_FRP_Replaceable from "../Specular.FRP.Replaceable/index.js";
import * as Specular_FormField from "../Specular.FormField/index.js";
import * as Specular_MultiChoiceRef from "../Specular.MultiChoiceRef/index.js";
import * as Specular_Profiling from "../Specular.Profiling/index.js";
import * as Specular_Ref from "../Specular.Ref/index.js";
import * as Specular_Select from "../Specular.Select/index.js";
import * as Type_Data_Boolean from "../Type.Data.Boolean/index.js";
import * as Type_Equality from "../Type.Equality/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
import * as Unsafe_Coerce from "../Unsafe.Coerce/index.js";
var write1 = /* #__PURE__ */ Specular_Ref.write(Effect_Class.monadEffectEffect);
var map = /* #__PURE__ */ Data_Functor.map(Specular_FRP_Base.functorDynamic);
var pure = /* #__PURE__ */ Control_Applicative.pure(Effect.applicativeEffect);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic);
var identity = /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn);
var merge1 = /* #__PURE__ */ Record.merge()();
var triggerCallback = /* #__PURE__ */ Specular_Callback.triggerCallback();
var bindFinal = /* #__PURE__ */ Restaumatic_Form_Final.bindFinal();
var pure2 = /* #__PURE__ */ Control_Applicative.pure(Restaumatic_Form_DynamicResult.applicativeDynamicResult);
var map1 = /* #__PURE__ */ Data_Functor.map(Restaumatic_Form_DynamicResult.functorDynamicResult);
var mwhen = /* #__PURE__ */ Data_Monoid_Extra.mwhen(Data_Monoid.monoidArray);
var bind = /* #__PURE__ */ Control_Bind.bind(Specular_FRP_Base.bindDynamic);
var wrap = /* #__PURE__ */ Data_Newtype.wrap();
var ordMaybe = /* #__PURE__ */ Data_Maybe.ordMaybe(/* #__PURE__ */ Data_Ord.ordArray(Data_Ord.ordString));
var lookup = /* #__PURE__ */ Data_Map_Internal.lookup(ordMaybe);
var unwrap = /* #__PURE__ */ Data_Newtype.unwrap();
var insertWith = /* #__PURE__ */ Data_Map_Internal.insertWith(ordMaybe);
var append = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var mapFlipped = /* #__PURE__ */ Data_Functor.mapFlipped(Data_Functor.functorArray);
var $$delete = /* #__PURE__ */ Data_Map_Internal["delete"](ordMaybe);
var map2 = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var map3 = /* #__PURE__ */ Data_Functor.map(Specular_Select.functorOption);
var lift2 = /* #__PURE__ */ Control_Apply.lift2(Restaumatic_Form_DynamicResult.applyDynamicResult);
var munless = /* #__PURE__ */ Data_Monoid_Extra.munless(Data_Monoid.monoidArray);
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showInt);
var apply = /* #__PURE__ */ Control_Apply.apply(Specular_FRP_Base.applyDynamic);
var readDynamic = /* #__PURE__ */ Specular_FRP_Base.readDynamic(Effect_Class.monadEffectEffect);
var for_ = /* #__PURE__ */ Data_Foldable.for_(Effect.applicativeEffect)(Data_Foldable.foldableMaybe);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit);
var measure = /* #__PURE__ */ Specular_Profiling.measure(Effect_Class.monadEffectEffect);
var mempty = /* #__PURE__ */ Data_Monoid.mempty(Data_Monoid.monoidArray);
var pure3 = /* #__PURE__ */ Control_Applicative.pure(/* #__PURE__ */ Data_Validation_Semigroup.applicativeV(Restaumatic_Form_Errors.semigroupFormErrors));
var traverse = /* #__PURE__ */ Data_Traversable.traverse(Data_Validation_Semigroup.traversableV)(Specular_FRP_Base.applicativeDynamic);
var bind2 = /* #__PURE__ */ Control_Bind.bind(Specular_FRP_Host.bindHost);
var pure4 = /* #__PURE__ */ Control_Applicative.pure(Specular_FRP_Host.applicativeHost);
var discard2 = /* #__PURE__ */ discard(Specular_FRP_Host.bindHost);
var updateRef = /* #__PURE__ */ Specular_Ref.updateRef(Effect_Class.monadEffectEffect);
var showRecord = /* #__PURE__ */ Data_Show.showRecord()();
var lastValidIsSymbol = {
    reflectSymbol: function () {
        return "lastValid";
    }
};
var showRecordFieldsConsNil = /* #__PURE__ */ Data_Show.showRecordFieldsConsNil(lastValidIsSymbol);
var UndefinedIsSymbol = {
    reflectSymbol: function () {
        return "Undefined";
    }
};
var editValueIsSymbol = {
    reflectSymbol: function () {
        return "editValue";
    }
};
var showRecordFieldsCons = /* #__PURE__ */ Data_Show.showRecordFieldsCons(editValueIsSymbol);
var errorIsSymbol = {
    reflectSymbol: function () {
        return "error";
    }
};
var showRecordFieldsCons1 = /* #__PURE__ */ Data_Show.showRecordFieldsCons(errorIsSymbol);
var showMaybe = /* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showString);
var InvalidIsSymbol = {
    reflectSymbol: function () {
        return "Invalid";
    }
};
var valueIsSymbol = {
    reflectSymbol: function () {
        return "value";
    }
};
var showRecordFieldsConsNil1 = /* #__PURE__ */ Data_Show.showRecordFieldsConsNil(valueIsSymbol);
var ValidIsSymbol = {
    reflectSymbol: function () {
        return "Valid";
    }
};
var mapFlipped1 = /* #__PURE__ */ Data_Functor.mapFlipped(Specular_FRP_Base.functorDynamic);
var sequence = /* #__PURE__ */ Data_Traversable.sequence(Data_Traversable.traversableArray)(Specular_FRP_Base.applicativeDynamic);
var find = /* #__PURE__ */ Data_Foldable.find(Data_Foldable.foldableArray);
var length = /* #__PURE__ */ Data_Foldable.length(Data_Foldable.foldableArray)(Data_Semiring.semiringInt);
var genericEncodeConstructor = /* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(UndefinedIsSymbol);
var encodeWithOptionsRecord = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord();
var encodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons();
var encodeRecordCons1 = /* #__PURE__ */ encodeRecordCons(Foreign_Generic_Class.encodeRecordNil);
var encodeRecordCons2 = /* #__PURE__ */ encodeRecordCons1(lastValidIsSymbol);
var genericEncodeConstructor1 = /* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(InvalidIsSymbol);
var encodeWithOptionsOther = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Form_Errors.encodeFormErrors);
var encodeWithOptionsOther1 = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.stringEncode));
var genericEncodeConstructor2 = /* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(ValidIsSymbol);
var encodeRecordCons3 = /* #__PURE__ */ encodeRecordCons1(valueIsSymbol);
var sequence1 = /* #__PURE__ */ Data_Traversable.sequence(Data_Traversable.traversableMaybe)(Specular_FRP_Base.applicativeDynamic);
var encode = /* #__PURE__ */ Foreign_Generic_Class.encode(/* #__PURE__ */ Foreign_Generic_Class.objectEncode(Foreign_Generic_Class.foreignEncode));
var fromFoldable = /* #__PURE__ */ Data_Set.fromFoldable(Data_Foldable.foldableArray);
var toUnfoldable = /* #__PURE__ */ Data_Set.toUnfoldable(Data_Unfoldable.unfoldableArray);
var composeFlipped = /* #__PURE__ */ Control_Semigroupoid.composeFlipped(Record_Builder.semigroupoidBuilder);
var insert = /* #__PURE__ */ Record_Builder.insert()();
var identity1 = /* #__PURE__ */ Control_Category.identity(Record_Builder.categoryBuilder);
var rowListIntersection = /* #__PURE__ */ Data_Record_Extra2.rowListIntersection()()()()(Type_Data_Boolean.isBooleanTrue);
var map4 = /* #__PURE__ */ Data_Functor.map(Specular_FRP_Host.functorHost);
var fromFoldable1 = /* #__PURE__ */ Foreign_Object.fromFoldable(Data_Foldable.foldableArray);
var toUnfoldable1 = /* #__PURE__ */ Foreign_Object.toUnfoldable(Data_Unfoldable.unfoldableArray);
var WithOptions = function (x) {
    return x;
};
var WithId = /* #__PURE__ */ (function () {
    function WithId(value0) {
        this.value0 = value0;
    };
    WithId.create = function (value0) {
        return new WithId(value0);
    };
    return WithId;
})();
var Undefined = /* #__PURE__ */ (function () {
    function Undefined(value0) {
        this.value0 = value0;
    };
    Undefined.create = function (value0) {
        return new Undefined(value0);
    };
    return Undefined;
})();
var Invalid = /* #__PURE__ */ (function () {
    function Invalid(value0) {
        this.value0 = value0;
    };
    Invalid.create = function (value0) {
        return new Invalid(value0);
    };
    return Invalid;
})();
var Valid = /* #__PURE__ */ (function () {
    function Valid(value0) {
        this.value0 = value0;
    };
    Valid.create = function (value0) {
        return new Valid(value0);
    };
    return Valid;
})();
var SomeInitialValue = /* #__PURE__ */ (function () {
    function SomeInitialValue(value0) {
        this.value0 = value0;
    };
    SomeInitialValue.create = function (value0) {
        return new SomeInitialValue(value0);
    };
    return SomeInitialValue;
})();
var RefWithOptions = function (x) {
    return x;
};
var NoInitializer = /* #__PURE__ */ (function () {
    function NoInitializer() {

    };
    NoInitializer.value = new NoInitializer();
    return NoInitializer;
})();
var NoInitialValue = /* #__PURE__ */ (function () {
    function NoInitialValue() {

    };
    NoInitialValue.value = new NoInitialValue();
    return NoInitialValue;
})();
var MetadataInitializer = /* #__PURE__ */ (function () {
    function MetadataInitializer(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    MetadataInitializer.create = function (value0) {
        return function (value1) {
            return new MetadataInitializer(value0, value1);
        };
    };
    return MetadataInitializer;
})();
var Metadata = function (x) {
    return x;
};
var MappedField = function (x) {
    return x;
};
var InitialValueInitializer = /* #__PURE__ */ (function () {
    function InitialValueInitializer(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    InitialValueInitializer.create = function (value0) {
        return function (value1) {
            return new InitialValueInitializer(value0, value1);
        };
    };
    return InitialValueInitializer;
})();
var FormDefM = function (x) {
    return x;
};
var EffectInitializer = function (x) {
    return x;
};
var ContextInitializer = /* #__PURE__ */ (function () {
    function ContextInitializer(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    ContextInitializer.create = function (value0) {
        return function (value1) {
            return new ContextInitializer(value0, value1);
        };
    };
    return ContextInitializer;
})();
var mergeRef = function (dictTypeEquals) {
    var to = Type_Equality.to(dictTypeEquals);
    return {
        merge: function (x) {
            return function (ref) {
                return write1(ref)(to(x));
            };
        }
    };
};
var maybeGetInitializer$primeTrue = function (dictIsSymbol) {
    var get = Record.get(dictIsSymbol)();
    return function () {
        return {
            "maybeGetInitializer'": function (v) {
                return function (label) {
                    return get(label);
                };
            }
        };
    };
};
var maybeGetInitializer$primeFalse = {
    "maybeGetInitializer'": function (v) {
        return function (v1) {
            return function (v2) {
                return NoInitializer.value;
            };
        };
    }
};
var maybeGetInitialValue$primeTrue = function (dictIsSymbol) {
    var get = Record.get(dictIsSymbol)();
    return function () {
        return {
            "maybeGetInitialValue'": function (v) {
                return function (label) {
                    var $972 = get(label);
                    return function ($973) {
                        return SomeInitialValue.create($972($973));
                    };
                };
            }
        };
    };
};
var maybeGetInitialValue$primeFals = {
    "maybeGetInitialValue'": function (v) {
        return function (v1) {
            return function (v2) {
                return NoInitialValue.value;
            };
        };
    }
};
var isRefLikeRef = {
    readRefLike: /* #__PURE__ */ (function () {
        var $974 = map(Data_Maybe.Just.create);
        return function ($975) {
            return $974(Specular_Ref.value($975));
        };
    })(),
    writeRefLike: function (ref) {
        return function (v) {
            if (v instanceof Valid) {
                return write1(ref)(v.value0.value);
            };
            return pure(Data_Unit.unit);
        };
    },
    touchRefLike: function (v) {
        return pure(Data_Unit.unit);
    }
};
var hasLabelRef = {
    getLabel: function (v) {
        return pure1(Data_Maybe.Nothing.value);
    }
};
var hasLabelFormField = {
    getLabel: function (v) {
        return pure1(Data_Maybe.Nothing.value);
    }
};
var hasFieldIdWithId = {
    getFieldId: function (v) {
        return v.value0.id;
    }
};
var hasFieldIdString = {
    getFieldId: identity
};
var hasFieldIdRef = function () {
    return {
        getFieldId: function (v) {
            return "";
        }
    };
};
var hasFieldIdFunctionEffect = function () {
    return {
        getFieldId: function (v) {
            return "";
        }
    };
};
var hasFieldIdFormField = function () {
    return {
        getFieldId: function (v) {
            return "";
        }
    };
};
var hasFieldIdEffect = function () {
    return {
        getFieldId: function (v) {
            return "";
        }
    };
};
var hasFieldIdChoiceRef = function () {
    return {
        getFieldId: function (v) {
            return "";
        }
    };
};
var hasErrorsRef = {
    displayedErrors: function (v) {
        return pure1([  ]);
    }
};
var hasErrorsChoiceRef = {
    displayedErrors: function (v) {
        return pure1([  ]);
    }
};
var hasContextRefContext = {
    getContext: Specular_Ref.value
};
var hasContextContext = {
    getContext: pure1
};
var addMetadataRecordNil = {
    addMetadataRecord: function (v) {
        return function (v1) {
            return function (r) {
                return r;
            };
        };
    }
};
var addMetadataMetadataRecord = function () {
    return function () {
        return {
            addMetadata: function (v) {
                return function (i1) {
                    return merge1(i1)({
                        label: v.label,
                        options: v.options
                    });
                };
            }
        };
    };
};
var addMetadataMetadataNoInit = {
    addMetadata: function (v) {
        return function (v1) {
            return {
                label: v.label,
                options: v.options
            };
        };
    }
};
var addMetadataFinalStringRec = function () {
    return function () {
        return {
            addMetadata: function (label) {
                return function (i1) {
                    return merge1(i1)({
                        label: label
                    });
                };
            }
        };
    };
};
var addMetadataFinalStringNoI = {
    addMetadata: function (label) {
        return function (v) {
            return {
                label: label
            };
        };
    }
};
var addMetadataEffectEffect = {
    addMetadata: function (v) {
        return function (i) {
            return i;
        };
    }
};
var addMetadataDynamicDynamic = {
    addMetadata: function (v) {
        return function (i) {
            return i;
        };
    }
};
var addErrorsRecordNil = {
    addErrorsRecord: function (v) {
        return function (v1) {
            return function (v2) {
                return pure(Data_Unit.unit);
            };
        };
    }
};
var addContextRef = {
    addContext: function (v) {
        return function (v1) {
            return pure(Data_Unit.unit);
        };
    }
};
var addContextFormField = {
    addContext: function (v) {
        return function (v1) {
            return pure(Data_Unit.unit);
        };
    }
};
var addContextEffect = {
    addContext: function (v) {
        return function (v1) {
            return pure(Data_Unit.unit);
        };
    }
};
var addContextDynamic = {
    addContext: function (v) {
        return function (v1) {
            return pure(Data_Unit.unit);
        };
    }
};
var writeRefLike = function (dict) {
    return dict.writeRefLike;
};
var writeRef = function () {
    return write1;
};
var writeRef1 = /* #__PURE__ */ writeRef();
var isTextFieldFormFieldStrin = {
    textInput: function (f) {
        return {
            onChange: function (value) {
                return writeRef1(Specular_FormField.editRef(f))(value);
            },
            onTouch: triggerCallback(Specular_FormField.focusOutCallback(f))(Data_Unit.unit),
            displayedValue: Specular_Ref.value(Specular_FormField.editRef(f)),
            placeholder: pure1("")
        };
    }
};
var isTextFieldRefString = {
    textInput: function (f) {
        return {
            onChange: function (value) {
                return writeRef1(f)(value);
            },
            onTouch: pure(Data_Unit.unit),
            displayedValue: Specular_Ref.value(f),
            placeholder: pure1("")
        };
    }
};
var withMetadata = /* #__PURE__ */ (function () {
    return MetadataInitializer.create;
})();
var withInitialValue = /* #__PURE__ */ (function () {
    return InitialValueInitializer.create;
})();
var withId = function (id) {
    return function (field) {
        return new WithId({
            id: id,
            field: field
        });
    };
};
var withFinal_ = function (dictMonadReplace) {
    var withDynamic_ = Specular_FRP_Replaceable.withDynamic_(dictMonadReplace);
    return function (dictMonadFRP) {
        var withDynamic_1 = withDynamic_(dictMonadFRP);
        var traverse_ = Data_Foldable.traverse_(((dictMonadFRP.MonadCleanup1()).Monad0()).Applicative0())(Data_Foldable.foldableMaybe);
        return function (f) {
            return function (block) {
                return withDynamic_1(Restaumatic_Form_Final.unFinal(f))(traverse_(block));
            };
        };
    };
};
var withEffect = EffectInitializer;
var withContext = /* #__PURE__ */ (function () {
    return ContextInitializer.create;
})();
var validateWhenValueJust = function (validation) {
    return function (paramF) {
        return function (value) {
            return bindFinal(paramF)(function (v) {
                if (v instanceof Data_Maybe.Nothing) {
                    return pure2([  ]);
                };
                if (v instanceof Data_Maybe.Just) {
                    return validation(pure2(v.value0))(value);
                };
                throw new Error("Failed pattern match at Restaumatic.Form.Internal (line 864, column 3 - line 866, column 48): " + [ v.constructor.name ]);
            });
        };
    };
};
var validateWhenJust = function (validation) {
    return function (paramF) {
        return function (value) {
            return bindFinal(paramF)(function (v) {
                if (v instanceof Data_Maybe.Nothing) {
                    return pure2([  ]);
                };
                if (v instanceof Data_Maybe.Just) {
                    return validation(pure2(v.value0))(value);
                };
                throw new Error("Failed pattern match at Restaumatic.Form.Internal (line 858, column 3 - line 860, column 48): " + [ v.constructor.name ]);
            });
        };
    };
};
var validateTrue = /* #__PURE__ */ map1(function (v) {
    return mwhen(v === false)([ Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.form.errors.required) ]);
});
var validateJust = function (validation) {
    return function (value) {
        return bindFinal(value)(function (v) {
            if (v instanceof Data_Maybe.Just) {
                return validation(pure2(v.value0));
            };
            if (v instanceof Data_Maybe.Nothing) {
                return pure2([  ]);
            };
            throw new Error("Failed pattern match at Restaumatic.Form.Internal (line 823, column 51 - line 825, column 21): " + [ v.constructor.name ]);
        });
    };
};
var validateJustIf = function (v) {
    return function (v1) {
        return function (v2) {
            if (!v) {
                return pure2([  ]);
            };
            if (v) {
                return validateJust(v1)(v2);
            };
            throw new Error("Failed pattern match at Restaumatic.Form.Internal (line 827, column 1 - line 827, column 76): " + [ v.constructor.name, v1.constructor.name, v2.constructor.name ]);
        };
    };
};
var unFinalWithDefault = function (def) {
    var $976 = map(Data_Maybe.fromMaybe(def));
    return function ($977) {
        return $976(Restaumatic_Form_Final.unFinal($977));
    };
};
var unFinalFromContextDef = function (d) {
    return function (key) {
        return function (ctxRef) {
            return bind(Specular_Ref.value(ctxRef))(function (context) {
                return Data_Maybe.maybe(pure1(d))(unFinalWithDefault(d))(Data_Vault.lookup(key)(context));
            });
        };
    };
};
var touchRefLike = function (dict) {
    return dict.touchRefLike;
};
var toRecord = function (dict) {
    return dict.toRecord;
};
var toArray = function (dict) {
    return dict.toArray;
};
var textInput = function (dict) {
    return dict.textInput;
};
var isTextFieldWithId = function (dictIsTextField) {
    var textInput1 = textInput(dictIsTextField);
    return {
        textInput: function (v) {
            return textInput1(v.value0.field);
        }
    };
};
var tagErrors = function (fieldName) {
    return function (label) {
        return function (errors) {
            return wrap((function () {
                var v = lookup(Data_Maybe.Nothing.value)(unwrap(errors));
                if (v instanceof Data_Maybe.Just) {
                    return insertWith(append)(new Data_Maybe.Just(fieldName))(mapFlipped(v.value0)(function (error) {
                        var $721 = {};
                        for (var $722 in error) {
                            if ({}.hasOwnProperty.call(error, $722)) {
                                $721[$722] = error[$722];
                            };
                        };
                        $721.fieldName = new Data_Maybe.Just(fieldName);
                        $721.fieldLabel = label;
                        return $721;
                    }));
                };
                if (v instanceof Data_Maybe.Nothing) {
                    return identity;
                };
                throw new Error("Failed pattern match at Restaumatic.Form.Internal (line 676, column 9 - line 679, column 30): " + [ v.constructor.name ]);
            })()($$delete(Data_Maybe.Nothing.value)(unwrap(errors))));
        };
    };
};
var singleOption = function (label) {
    return function (key) {
        return new Specular_Select.SingleOption({
            label: label,
            key: key,
            disabled: false
        });
    };
};
var withNothing = function (emptyLabel) {
    return function (opts) {
        return append([ singleOption(emptyLabel)(Data_Maybe.Nothing.value) ])(map2(map3(Data_Maybe.Just.create))(opts));
    };
};
var withOptions = function (field) {
    return function (label) {
        return {
            field: field,
            toOption: function (a) {
                return singleOption(label(a))(a);
            }
        };
    };
};
var shorterThan = /* #__PURE__ */ lift2(function (threshold) {
    return function (value) {
        return munless(Data_String_CodePoints.length(value) <= threshold)([ Restaumatic_I18n.translate(Restaumatic_Common_Translations_Keys.t.form.errors.shorterThan)({
            threshold: show(threshold)
        }) ]);
    };
});
var selectWriteValue = function (dict) {
    return dict.selectWriteValue;
};
var selectTouch = function (dict) {
    return dict.selectTouch;
};
var selectReadValue = function (dict) {
    return dict.selectReadValue;
};
var selectGetOptions = function (dict) {
    return dict.selectGetOptions;
};
var selectInput = function (dictEq) {
    var containsKey = Specular_Select.containsKey(dictEq);
    return function (dictIsSelectField) {
        var selectWriteValue1 = selectWriteValue(dictIsSelectField);
        var selectReadValue1 = selectReadValue(dictIsSelectField);
        var selectGetOptions1 = selectGetOptions(dictIsSelectField);
        var selectTouch1 = selectTouch(dictIsSelectField);
        return function (field) {
            var extraOption = function (stdOptions) {
                return function (value) {
                    if (value instanceof Data_Maybe.Just && Data_Array.any(containsKey(value.value0))(stdOptions)) {
                        return [  ];
                    };
                    if (value instanceof Data_Maybe.Just) {
                        return [ new Specular_Select.SingleOption({
                            key: new Data_Maybe.Just(value.value0),
                            label: "",
                            disabled: false
                        }) ];
                    };
                    if (value instanceof Data_Maybe.Nothing) {
                        return [ new Specular_Select.SingleOption({
                            key: Data_Maybe.Nothing.value,
                            label: "",
                            disabled: false
                        }) ];
                    };
                    throw new Error("Failed pattern match at Restaumatic.Form.Internal (line 1126, column 5 - line 1132, column 70): " + [ value.constructor.name ]);
                };
            };
            return {
                onChange: function (v) {
                    if (v instanceof Data_Maybe.Just) {
                        return selectWriteValue1(field)(v.value0);
                    };
                    if (v instanceof Data_Maybe.Nothing) {
                        return pure(Data_Unit.unit);
                    };
                    throw new Error("Failed pattern match at Restaumatic.Form.Internal (line 1111, column 7 - line 1116, column 20): " + [ v.constructor.name ]);
                },
                displayedValue: map(Data_Maybe.Just.create)(selectReadValue1(field)),
                displayedOptions: apply(map(function (v) {
                    return function (v1) {
                        return append(extraOption(v)(v1))(map2(map3(Data_Maybe.Just.create))(v));
                    };
                })(selectGetOptions1(field)))(selectReadValue1(field)),
                onTouch: selectTouch1(field)
            };
        };
    };
};
var isSelectFieldWithId = function (dictIsSelectField) {
    var selectWriteValue1 = selectWriteValue(dictIsSelectField);
    var selectReadValue1 = selectReadValue(dictIsSelectField);
    var selectGetOptions1 = selectGetOptions(dictIsSelectField);
    var selectTouch1 = selectTouch(dictIsSelectField);
    return {
        selectWriteValue: function (v) {
            return selectWriteValue1(v.value0.field);
        },
        selectReadValue: function (v) {
            return selectReadValue1(v.value0.field);
        },
        selectGetOptions: function (v) {
            return selectGetOptions1(v.value0.field);
        },
        selectTouch: function (v) {
            return selectTouch1(v.value0.field);
        }
    };
};
var runFormDefM = function (dictMonadFRP) {
    var liftHost = Specular_FRP_Host.liftHost(dictMonadFRP.MonadCleanup1())(dictMonadFRP.MonadEffect0());
    return function (v) {
        return liftHost(v);
    };
};
var runFormDefM1 = /* #__PURE__ */ runFormDefM(/* #__PURE__ */ Specular_FRP_Base.monadFRP(Specular_FRP_Host.monadEffectHost)(Specular_FRP_Host.monadCleanupHost));
var requiredError = function (v) {
    return Restaumatic_Form_Errors.userVisibleError(Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.form.errors.required));
};
var readRefLike = function (dict) {
    return dict.readRefLike;
};
var isRefLikeFormField = {
    readRefLike: /* #__PURE__ */ (function () {
        var $978 = readRefLike(isRefLikeRef);
        return function ($979) {
            return $978(Specular_FormField.editRef($979));
        };
    })(),
    writeRefLike: /* #__PURE__ */ (function () {
        var $980 = writeRefLike(isRefLikeRef);
        return function ($981) {
            return $980(Specular_FormField.editRef($981));
        };
    })(),
    touchRefLike: function (field) {
        return Specular_FormField.focusOutCallback(field)(Data_Unit.unit);
    }
};
var isRefLikeWithId = function (dictIsRefLike) {
    var writeRefLike1 = writeRefLike(dictIsRefLike);
    var readRefLike1 = readRefLike(dictIsRefLike);
    var touchRefLike1 = touchRefLike(dictIsRefLike);
    return {
        writeRefLike: function (v) {
            return writeRefLike1(v.value0.field);
        },
        readRefLike: function (v) {
            return readRefLike1(v.value0.field);
        },
        touchRefLike: function (v) {
            return touchRefLike1(v.value0.field);
        }
    };
};
var optionForEq = function () {
    return Unsafe_Coerce.unsafeCoerce;
};
var nonEmpty = /* #__PURE__ */ map1(function (s) {
    return mwhen(s === "")([ Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.form.errors.required) ]);
});
var monadFormDefM = Specular_FRP_Host.monadHost;
var monadEffectFormDefM = Specular_FRP_Host.monadEffectHost;
var liftEffect = /* #__PURE__ */ Effect_Class.liftEffect(monadEffectFormDefM);
var monadCleanupFormDefM = Specular_FRP_Host.monadCleanupHost;
var onCleanup = /* #__PURE__ */ Control_Monad_Cleanup.onCleanup(monadCleanupFormDefM);
var modifyRefLike = function (dictMonadEffect) {
    var liftEffect1 = Effect_Class.liftEffect(dictMonadEffect);
    return function (dictIsRefLike) {
        var readRefLike1 = readRefLike(dictIsRefLike);
        var writeRefLike1 = writeRefLike(dictIsRefLike);
        return function (field) {
            return function (fn) {
                return liftEffect1(function __do() {
                    var m_value = readDynamic(readRefLike1(field))();
                    return for_(m_value)(function (value) {
                        return writeRefLike1(field)(new Valid({
                            value: fn(value),
                            editValue: Data_Maybe.Nothing.value
                        }));
                    })();
                });
            };
        };
    };
};
var mergeUnit = function (dictTypeEquals) {
    return {
        merge: function (v) {
            return function (v1) {
                return pure(Data_Unit.unit);
            };
        }
    };
};
var mergeRecordNil = {
    mergeRecord: function (v) {
        return function (v1) {
            return function (v2) {
                return pure(Data_Unit.unit);
            };
        };
    }
};
var mergeRecord = function (dict) {
    return dict.mergeRecord;
};
var merge_Record = function (dictAsRecord) {
    var toRecord1 = toRecord(dictAsRecord);
    return function () {
        return function (dictMergeRecord) {
            var mergeRecord1 = mergeRecord(dictMergeRecord);
            return {
                merge: function (d) {
                    return function (f) {
                        return mergeRecord1(Type_Proxy["Proxy"].value)(toRecord1(d))(f);
                    };
                }
            };
        };
    };
};
var mergeInputRequired = function (dict) {
    return dict.mergeInputRequired;
};
var merge = function (dict) {
    return dict.merge;
};
var mergeRecordCons = function (dictIsSymbol) {
    var reflectSymbol = Data_Symbol.reflectSymbol(dictIsSymbol);
    var get = Record.get(dictIsSymbol)();
    return function (dictMergeRecord) {
        var mergeRecord1 = mergeRecord(dictMergeRecord);
        return function (dictMerge) {
            var merge2 = merge(dictMerge);
            return function () {
                return function () {
                    return function () {
                        return function () {
                            return {
                                mergeRecord: function (v) {
                                    return function (r) {
                                        return function (f) {
                                            return function __do() {
                                                measure("merge " + reflectSymbol(Type_Proxy["Proxy"].value))(merge2(get(Type_Proxy["Proxy"].value)(r))(get(Type_Proxy["Proxy"].value)(f)))();
                                                return mergeRecord1(Type_Proxy["Proxy"].value)(r)(f)();
                                            };
                                        };
                                    };
                                }
                            };
                        };
                    };
                };
            };
        };
    };
};
var write = function (dictMerge) {
    var merge2 = merge(dictMerge);
    return function (dictMonadEffect) {
        var liftEffect1 = Effect_Class.liftEffect(dictMonadEffect);
        return function (field) {
            return function (value) {
                return liftEffect1(merge2(value)(field));
            };
        };
    };
};
var mergeChoiceRef = function (dictTypeEquals) {
    var merge2 = merge(mergeRef(dictTypeEquals));
    return {
        merge: function (x) {
            return function (ref) {
                return merge2(x)(Specular_ChoiceRef.currentChoice(ref));
            };
        }
    };
};
var mergeDelayed = function (dictMerge) {
    var merge2 = merge(dictMerge);
    return {
        merge: function (x) {
            return function (v) {
                return function __do() {
                    var field = readDynamic(v)();
                    return merge2(x)(field)();
                };
            };
        }
    };
};
var mergeT2T2 = function (dictMerge) {
    var merge2 = merge(dictMerge);
    return function (dictMerge1) {
        var merge3 = merge(dictMerge1);
        return {
            merge: function (v) {
                return function (v1) {
                    return function __do() {
                        merge2(v.value0)(v1.value0)();
                        return merge3(v.value1)(v1.value1)();
                    };
                };
            }
        };
    };
};
var maybeGetInitializer$prime = function (dict) {
    return dict["maybeGetInitializer'"];
};
var maybeGetInitializer1 = function () {
    return function (dictMaybeGetInitializer$prime) {
        return {
            maybeGetInitializer: maybeGetInitializer$prime(dictMaybeGetInitializer$prime)(Type_Proxy["Proxy"].value)
        };
    };
};
var maybeGetInitializer = function (dict) {
    return dict.maybeGetInitializer;
};
var maybeGetInitialValue$prime = function (dict) {
    return dict["maybeGetInitialValue'"];
};
var maybeGetInitialValue1 = function () {
    return function (dictMaybeGetInitialValue$prime) {
        return {
            maybeGetInitialValue: maybeGetInitialValue$prime(dictMaybeGetInitialValue$prime)(Type_Proxy["Proxy"].value)
        };
    };
};
var maybeGetInitialValue = function (dict) {
    return dict.maybeGetInitialValue;
};
var maybeContainerToArray = function (dictContainer) {
    var toArray1 = toArray(dictContainer);
    return function (v) {
        if (v instanceof Data_Maybe.Nothing) {
            return mempty;
        };
        if (v instanceof Data_Maybe.Just) {
            return toArray1(v.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.Form.Internal (line 1097, column 1 - line 1097, column 73): " + [ v.constructor.name ]);
    };
};
var mapVFinal = function (f) {
    var $982 = map(Data_Validation_Semigroup.validation(Data_Validation_Semigroup.invalid)(f));
    return function ($983) {
        return Restaumatic_Form_Final.makeFinalV($982(Restaumatic_Form_Final.unFinalV($983)));
    };
};
var mapMaybeFinalUserVisible = function (errorMessage) {
    return function (f) {
        var f$prime = function (x) {
            var v = f(x);
            if (v instanceof Data_Maybe.Nothing) {
                return Data_Validation_Semigroup.invalid(Restaumatic_Form_Errors.userVisibleError(errorMessage));
            };
            if (v instanceof Data_Maybe.Just) {
                return pure3(v.value0);
            };
            throw new Error("Failed pattern match at Restaumatic.Form.Internal (line 642, column 5 - line 644, column 23): " + [ v.constructor.name ]);
        };
        var $984 = map(Data_Validation_Semigroup.validation(Data_Validation_Semigroup.invalid)(f$prime));
        return function ($985) {
            return Restaumatic_Form_Final.makeFinalV($984(Restaumatic_Form_Final.unFinalV($985)));
        };
    };
};
var mapMaybeFinalInternal = function (errorMessage) {
    return function (f) {
        var f$prime = function (x) {
            var v = f(x);
            if (v instanceof Data_Maybe.Nothing) {
                return Data_Validation_Semigroup.invalid(Restaumatic_Form_Errors.internalError(errorMessage));
            };
            if (v instanceof Data_Maybe.Just) {
                return pure3(v.value0);
            };
            throw new Error("Failed pattern match at Restaumatic.Form.Internal (line 652, column 5 - line 654, column 23): " + [ v.constructor.name ]);
        };
        var $986 = map(Data_Validation_Semigroup.validation(Data_Validation_Semigroup.invalid)(f$prime));
        return function ($987) {
            return Restaumatic_Form_Final.makeFinalV($986(Restaumatic_Form_Final.unFinalV($987)));
        };
    };
};
var mapMaybeFinal = /* #__PURE__ */ mapMaybeFinalInternal("Unknown error (mapMaybeFinal)");
var mapDynamicFinal = function (f) {
    return function ($988) {
        return Restaumatic_Form_Final.makeFinalV((function (v) {
            return bind(v)(traverse(f));
        })(Restaumatic_Form_Final.unFinalV($988)));
    };
};
var makeWithInitialValueInitializer = function (dict) {
    return dict.makeWithInitialValueInitializer;
};
var initializeInitialValueIni = function (dictMakeWithInitialValueInitializer) {
    return {
        makeImpl: makeWithInitialValueInitializer(dictMakeWithInitialValueInitializer)
    };
};
var makeRecordImpl = function (dict) {
    return dict.makeRecordImpl;
};
var initializeSomeInitialValu = function (dictAsRecord) {
    var toRecord1 = toRecord(dictAsRecord);
    return function () {
        return function (dictInitializeRecord) {
            var makeRecordImpl1 = makeRecordImpl(dictInitializeRecord);
            return {
                makeImpl: function (p) {
                    return function (opts) {
                        return bind2(makeRecordImpl1(p)(Type_Proxy["Proxy"].value)(opts))(function (v) {
                            return pure4({
                                field: Record_Builder.buildFromScratch(v.field),
                                init: function (v1) {
                                    return v.init(toRecord1(v1.value0));
                                }
                            });
                        });
                    };
                }
            };
        };
    };
};
var makeImpl = function (dict) {
    return dict.makeImpl;
};
var makeWithDefaultInitializer = function (dictInitialize) {
    var makeImpl1 = makeImpl(dictInitialize);
    return function (defaultInitializer) {
        return function (p) {
            return function (opts) {
                return bind2(makeImpl1(p)(opts))(function (v) {
                    return pure4({
                        field: v.field,
                        init: function (iv) {
                            return function (v1) {
                                return v.init(iv)(defaultInitializer);
                            };
                        }
                    });
                });
            };
        };
    };
};
var initializeNoInitializerRe = function (dictInitialize) {
    return {
        makeImpl: makeWithDefaultInitializer(dictInitialize)({})
    };
};
var initializeNoInitialValueR = function (dictInitialize) {
    var makeImpl1 = makeImpl(dictInitialize);
    return {
        makeImpl: function (p) {
            return function (opts) {
                return bind2(makeImpl1(p)(opts))(function (v) {
                    return pure4({
                        field: v.field,
                        init: function (v1) {
                            return v.init(new SomeInitialValue({}));
                        }
                    });
                });
            };
        }
    };
};
var makeWithInitialValueIniti = function (dictInitialize) {
    var makeImpl1 = makeImpl(dictInitialize);
    return {
        makeWithInitialValueInitializer: function (p) {
            return function (opts) {
                return bind2(makeImpl1(p)(opts))(function (v) {
                    return pure4({
                        field: v.field,
                        init: function (v1) {
                            return function (v2) {
                                return v.init(new SomeInitialValue(v2.value0))(v2.value1);
                            };
                        }
                    });
                });
            };
        }
    };
};
var makeWithInitialValueIniti1 = function (dictInitialize) {
    var makeImpl1 = makeImpl(dictInitialize);
    return {
        makeWithInitialValueInitializer: function (p) {
            return function (opts) {
                return bind2(makeImpl1(p)(opts))(function (v) {
                    return pure4({
                        field: v.field,
                        init: function (given_iv) {
                            return function (v1) {
                                return v.init(given_iv)(v1.value1);
                            };
                        }
                    });
                });
            };
        }
    };
};
var make = function (dictMonadFRP) {
    var liftHost = Specular_FRP_Host.liftHost(dictMonadFRP.MonadCleanup1())(dictMonadFRP.MonadEffect0());
    return function (dictInitialize) {
        var makeImpl1 = makeImpl(dictInitialize);
        return function (name) {
            return function (f) {
                return liftHost(bind2(makeImpl1(Type_Proxy["Proxy"].value)({
                    name: name
                }))(function (v) {
                    return discard2(runFormDefM1(v.init(NoInitialValue.value)(f(pure1(v.field)))))(function () {
                        return pure4(v.field);
                    });
                }));
            };
        };
    };
};
var mSelectWriteValue = function (dict) {
    return dict.mSelectWriteValue;
};
var mSelectTouch = function (dict) {
    return dict.mSelectTouch;
};
var mSelectReadValue = function (dict) {
    return dict.mSelectReadValue;
};
var mSelectGetOptions = function (dict) {
    return dict.mSelectGetOptions;
};
var isMultiSelectFieldWithId = function (dictIsMultiSelectField) {
    var mSelectWriteValue1 = mSelectWriteValue(dictIsMultiSelectField);
    var mSelectReadValue1 = mSelectReadValue(dictIsMultiSelectField);
    var mSelectGetOptions1 = mSelectGetOptions(dictIsMultiSelectField);
    var mSelectTouch1 = mSelectTouch(dictIsMultiSelectField);
    return {
        mSelectWriteValue: function (v) {
            return mSelectWriteValue1(v.value0.field);
        },
        mSelectReadValue: function (v) {
            return mSelectReadValue1(v.value0.field);
        },
        mSelectGetOptions: function (v) {
            return mSelectGetOptions1(v.value0.field);
        },
        mSelectTouch: function (v) {
            return mSelectTouch1(v.value0.field);
        }
    };
};
var liftMaybe = function ($989) {
    return Restaumatic_Form_Final.makeFinal(pure1($989));
};
var lessThanOrEqual = function (dictOrd) {
    var lessThanOrEq1 = Data_Ord.lessThanOrEq(dictOrd);
    return function (dictShow) {
        var show1 = Data_Show.show(dictShow);
        return lift2(function (threshold) {
            return function (value) {
                return munless(lessThanOrEq1(value)(threshold))([ Restaumatic_I18n.translate(Restaumatic_Common_Translations_Keys.t.form.errors.lessThanOrEqual)({
                    threshold: show1(threshold)
                }) ]);
            };
        });
    };
};
var lessThan = function (dictOrd) {
    var lessThan1 = Data_Ord.lessThan(dictOrd);
    return function (dictShow) {
        var show1 = Data_Show.show(dictShow);
        return lift2(function (threshold) {
            return function (value) {
                return munless(lessThan1(value)(threshold))([ Restaumatic_I18n.translate(Restaumatic_Common_Translations_Keys.t.form.errors.lessThan)({
                    threshold: show1(threshold)
                }) ]);
            };
        });
    };
};
var isSelectFieldRefWithOptions = function (dictIsRefLike) {
    var writeRefLike1 = writeRefLike(dictIsRefLike);
    var readRefLike1 = readRefLike(dictIsRefLike);
    var touchRefLike1 = touchRefLike(dictIsRefLike);
    return {
        selectWriteValue: function (v) {
            return function (value) {
                return writeRefLike1(v.field)(new Valid({
                    value: value,
                    editValue: Data_Maybe.Nothing.value
                }));
            };
        },
        selectReadValue: function (v) {
            return readRefLike1(v.field);
        },
        selectGetOptions: function (v) {
            return v.choices;
        },
        selectTouch: function (v) {
            return touchRefLike1(v.field);
        }
    };
};
var isSelectFieldChoiceRef = {
    selectWriteValue: function (v) {
        return function (a) {
            return write1(v.field.currentChoice)(a);
        };
    },
    selectReadValue: function (v) {
        return map(Data_Maybe.Just.create)(Specular_Ref.value(Specular_ChoiceRef.currentChoice(v.field)));
    },
    selectGetOptions: function (v) {
        return map(map2(v.toOption))(Specular_ChoiceRef.choices(v.field));
    },
    selectTouch: function (v) {
        return pure(Data_Unit.unit);
    }
};
var isMultiSelectFieldMultiChoiceRef = {
    mSelectWriteValue: function (v) {
        return function (a) {
            return updateRef(v.field.currentChoices)(a);
        };
    },
    mSelectReadValue: function (v) {
        return Specular_Ref.value(Specular_MultiChoiceRef.currentChoices(v.field));
    },
    mSelectGetOptions: function (v) {
        return map(map2(v.toOption))(Specular_MultiChoiceRef.choices(v.field));
    },
    mSelectTouch: function (v) {
        return pure(Data_Unit.unit);
    }
};
var initializerFor = function (dictInitialize) {
    return identity;
};
var hasOptionsSingle = {};
var hasOptionsSet = {};
var hasOptionsSMultiSet = {};
var hasOptionsArray = {};
var hasErrorsOldFormField = {
    displayedErrors: Specular_FormField.displayedErrors
};
var hasErrorsErrorArray = {
    displayedErrors: /* #__PURE__ */ unFinalWithDefault(mempty)
};
var greaterThanOrEqualFmt = function (dictOrd) {
    var greaterThanOrEq = Data_Ord.greaterThanOrEq(dictOrd);
    return function (display) {
        return lift2(function (threshold) {
            return function (value) {
                return munless(greaterThanOrEq(value)(threshold))([ Restaumatic_I18n.translate(Restaumatic_Common_Translations_Keys.t.form.errors.greaterThanOrEqual)({
                    threshold: display(threshold)
                }) ]);
            };
        });
    };
};
var greaterThanOrEqual = function (dictOrd) {
    var greaterThanOrEq = Data_Ord.greaterThanOrEq(dictOrd);
    return function (dictShow) {
        var show1 = Data_Show.show(dictShow);
        return lift2(function (threshold) {
            return function (value) {
                return munless(greaterThanOrEq(value)(threshold))([ Restaumatic_I18n.translate(Restaumatic_Common_Translations_Keys.t.form.errors.greaterThanOrEqual)({
                    threshold: show1(threshold)
                }) ]);
            };
        });
    };
};
var greaterThan = function (dictOrd) {
    var greaterThan2 = Data_Ord.greaterThan(dictOrd);
    return function (dictShow) {
        var show1 = Data_Show.show(dictShow);
        return lift2(function (threshold) {
            return function (value) {
                return munless(greaterThan2(value)(threshold))([ Restaumatic_I18n.translate(Restaumatic_Common_Translations_Keys.t.form.errors.greaterThan)({
                    threshold: show1(threshold)
                }) ]);
            };
        });
    };
};
var getLabel = function (dict) {
    return dict.getLabel;
};
var hasLabelMappedField = function (dictHasLabel) {
    var getLabel1 = getLabel(dictHasLabel);
    return {
        getLabel: function (v) {
            return getLabel1(v.field);
        }
    };
};
var hasLabelRefWithOptions = function (dictHasLabel) {
    var getLabel1 = getLabel(dictHasLabel);
    return {
        getLabel: function (v) {
            return getLabel1(v.field);
        }
    };
};
var hasLabelWithId = function (dictHasLabel) {
    var getLabel1 = getLabel(dictHasLabel);
    return {
        getLabel: function (v) {
            return getLabel1(v.value0.field);
        }
    };
};
var getFieldId = function (dict) {
    return dict.getFieldId;
};
var hasFieldIdRefWithOptions = function (dictHasFieldId) {
    var getFieldId1 = getFieldId(dictHasFieldId);
    return {
        getFieldId: function (v) {
            return getFieldId1(v.field);
        }
    };
};
var hasFieldIdWithOptions = function (dictHasFieldId) {
    var getFieldId1 = getFieldId(dictHasFieldId);
    return {
        getFieldId: function (v) {
            return getFieldId1(v.field);
        }
    };
};
var getContext = function (dict) {
    return dict.getContext;
};
var unFinalFromContext = function (dictHasContext) {
    var getContext1 = getContext(dictHasContext);
    return function (key) {
        return function (field) {
            return bind(getContext1(field))(function (ctx) {
                return Data_Maybe.maybe(pure1(Data_Maybe.Nothing.value))(Restaumatic_Form_Final.unFinal)(Data_Vault.lookup(key)(ctx));
            });
        };
    };
};
var hasContextDelayed = function (dictHasContext) {
    var getContext1 = getContext(dictHasContext);
    return {
        getContext: function (v) {
            return bind(v)(getContext1);
        }
    };
};
var hasContextWithId = function (dictHasContext) {
    var getContext1 = getContext(dictHasContext);
    return {
        getContext: function (v) {
            return getContext1(v.value0.field);
        }
    };
};
var genericTypedValue = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new Undefined(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return new Invalid(x.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inr) {
            return new Valid(x.value0.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.Form.Internal (line 79, column 1 - line 79, column 64): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Undefined) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof Invalid) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
        };
        if (x instanceof Valid) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0));
        };
        throw new Error("Failed pattern match at Restaumatic.Form.Internal (line 79, column 1 - line 79, column 64): " + [ x.constructor.name ]);
    }
};
var genericShow = /* #__PURE__ */ Data_Show_Generic.genericShow(genericTypedValue);
var defaultEncode = /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericTypedValue);
var showTypedValue = function (dictShow) {
    var showRecordFieldsConsNil2 = showRecordFieldsConsNil(Restaumatic_Form_Value.showValue(dictShow));
    return {
        show: genericShow(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(showRecord(showRecordFieldsConsNil2)))(UndefinedIsSymbol))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(showRecord(showRecordFieldsCons(showRecordFieldsCons1(showRecordFieldsConsNil2)(Restaumatic_Form_Errors.showFormErrors))(showMaybe))))(InvalidIsSymbol))(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(showRecord(showRecordFieldsCons(showRecordFieldsConsNil1(dictShow))(showMaybe))))(ValidIsSymbol))))
    };
};
var functorFormDefM = Specular_FRP_Host.functorHost;
var fromRecord = function (dict) {
    return dict.fromRecord;
};
var fromChoices = function (dictFoldable) {
    var fromFoldable2 = Data_Array.fromFoldable(dictFoldable);
    return function (dictIsRefLike) {
        return function (field) {
            return function (cs) {
                return {
                    field: field,
                    choices: mapFlipped1(mapFlipped1(cs)(fromFoldable2))(map2(function (r) {
                        return singleOption(r.name)(r.id);
                    }))
                };
            };
        };
    };
};
var fromArray = function (dict) {
    return dict.fromArray;
};
var isMultiSelectFieldRefWith = function (dictContainer) {
    var fromArray1 = fromArray(dictContainer);
    var maybeContainerToArray1 = maybeContainerToArray(dictContainer);
    return function (dictIsRefLike) {
        var writeRefLike1 = writeRefLike(dictIsRefLike);
        var readRefLike1 = readRefLike(dictIsRefLike);
        return {
            mSelectWriteValue: function (v) {
                return function (value) {
                    return writeRefLike1(v.field)(new Valid({
                        value: fromArray1(value),
                        editValue: Data_Maybe.Nothing.value
                    }));
                };
            },
            mSelectReadValue: function (v) {
                return map(maybeContainerToArray1)(readRefLike1(v.field));
            },
            mSelectGetOptions: function (v) {
                return v.choices;
            },
            mSelectTouch: function (v) {
                return pure(Data_Unit.unit);
            }
        };
    };
};
var forceDisplayErrorsKey = /* #__PURE__ */ Effect_Unsafe.unsafePerformEffect(Data_Vault.newKey);
var forceDisplayErrors = /* #__PURE__ */ Data_Vault.singleton(forceDisplayErrorsKey);
var fieldPathToString = /* #__PURE__ */ Data_String_Common.joinWith(".");
var failFirst = function (validations_) {
    return function (value) {
        return bindFinal(value)(function (value_) {
            var validationValuesD = map2((function () {
                var $990 = map(Data_Maybe.fromMaybe([  ]));
                return function ($991) {
                    return $990(Restaumatic_Form_Final.unFinal((function (v) {
                        return v(pure2(value_));
                    })($991)));
                };
            })())(validations_);
            var validationValues = sequence(validationValuesD);
            var findFirst = (function () {
                var $992 = Data_Maybe.fromMaybe([  ]);
                var $993 = find(function (e) {
                    return length(e) > 0;
                });
                return function ($994) {
                    return $992($993($994));
                };
            })();
            var result = map(function ($995) {
                return Data_Maybe.Just.create(findFirst($995));
            })(validationValues);
            return Restaumatic_Form_Final.makeFinal(result);
        });
    };
};
var encodeTypedValue = function (dictEncode) {
    var encodeRecordCons4 = encodeRecordCons2(Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Form_Value.encodeValue(dictEncode)));
    var genericEncodeSum = Foreign_Generic_Class.genericEncodeSum(genericEncodeConstructor(Foreign_Generic_Class.genericEncodeArgsRecord(encodeWithOptionsRecord(encodeRecordCons4))));
    var genericEncodeSum1 = Foreign_Generic_Class.genericEncodeSum(genericEncodeConstructor1(Foreign_Generic_Class.genericEncodeArgsRecord(encodeWithOptionsRecord(encodeRecordCons(encodeRecordCons(encodeRecordCons4)(errorIsSymbol)(encodeWithOptionsOther))(editValueIsSymbol)(encodeWithOptionsOther1)))));
    return function (dictEncodeWithOptions) {
        return {
            encode: defaultEncode(genericEncodeSum(genericEncodeSum1(genericEncodeConstructor2(Foreign_Generic_Class.genericEncodeArgsRecord(encodeWithOptionsRecord(encodeRecordCons(encodeRecordCons3(dictEncodeWithOptions))(editValueIsSymbol)(encodeWithOptionsOther1)))))))
        };
    };
};
var dynamicFromContextDef = function (d) {
    return function (key) {
        return function (ctxRef) {
            return bind(Specular_Ref.value(ctxRef))(function (context) {
                return Data_Maybe.fromMaybe(pure1(d))(Data_Vault.lookup(key)(context));
            });
        };
    };
};
var dynamicFromContext = function (dictHasContext) {
    var getContext1 = getContext(dictHasContext);
    return function (key) {
        return function (field) {
            return bind(getContext1(field))(function (context) {
                return sequence1(Data_Vault.lookup(key)(context));
            });
        };
    };
};
var dumpStateRecordNil = {
    dumpStateRecord: function (v) {
        return function (v1) {
            return pure1(Foreign_Object.empty);
        };
    }
};
var dumpStateRecord = function (dict) {
    return dict.dumpStateRecord;
};
var dumpState_Record = function () {
    return function (dictDumpStateRecord) {
        return {
            dumpState: (function () {
                var $996 = map(encode);
                var $997 = dumpStateRecord(dictDumpStateRecord)(Type_Proxy["Proxy"].value);
                return function ($998) {
                    return $996($997($998));
                };
            })()
        };
    };
};
var dumpState = function (dict) {
    return dict.dumpState;
};
var dumpStateRecordCons = function (dictIsSymbol) {
    var reflectSymbol = Data_Symbol.reflectSymbol(dictIsSymbol);
    var get = Record.get(dictIsSymbol)();
    return function (dictDumpStateRecord) {
        var dumpStateRecord1 = dumpStateRecord(dictDumpStateRecord);
        return function (dictDumpState) {
            var dumpState1 = dumpState(dictDumpState);
            return function () {
                return function () {
                    return {
                        dumpStateRecord: function (v) {
                            return function (f) {
                                return apply(map(function (v1) {
                                    return function (v2) {
                                        return Foreign_Object.insert(reflectSymbol(Type_Proxy["Proxy"].value))(v1)(v2);
                                    };
                                })(dumpState1(get(Type_Proxy["Proxy"].value)(f))))(dumpStateRecord1(Type_Proxy["Proxy"].value)(f));
                            };
                        }
                    };
                };
            };
        };
    };
};
var displayedErrors = function (dict) {
    return dict.displayedErrors;
};
var hasDisplayedErrors = function (dictHasErrors) {
    var $999 = map(function ($1002) {
        return !Data_Array["null"]($1002);
    });
    var $1000 = displayedErrors(dictHasErrors);
    return function ($1001) {
        return $999($1000($1001));
    };
};
var hasErrorsDelayed = function (dictHasErrors) {
    var displayedErrors1 = displayedErrors(dictHasErrors);
    return {
        displayedErrors: function (v) {
            return bind(v)(displayedErrors1);
        }
    };
};
var hasErrorsMappedField = function (dictHasErrors) {
    var displayedErrors1 = displayedErrors(dictHasErrors);
    return {
        displayedErrors: function (v) {
            return displayedErrors1(v.field);
        }
    };
};
var hasErrorsRefWithOptions = function (dictHasErrors) {
    var displayedErrors1 = displayedErrors(dictHasErrors);
    return {
        displayedErrors: function (v) {
            return displayedErrors1(v.field);
        }
    };
};
var hasErrorsWithId = function (dictHasErrors) {
    var displayedErrors1 = displayedErrors(dictHasErrors);
    return {
        displayedErrors: function (v) {
            return displayedErrors1(v.value0.field);
        }
    };
};
var hasErrorsWithOptions = function (dictHasErrors) {
    var displayedErrors1 = displayedErrors(dictHasErrors);
    return {
        displayedErrors: function (v) {
            return displayedErrors1(v.field);
        }
    };
};
var displayLocaleKey = /* #__PURE__ */ Effect_Unsafe.unsafePerformEffect(Data_Vault.newKey);
var displayLocale = /* #__PURE__ */ Data_Vault.singleton(displayLocaleKey);
var copyState = function (dict) {
    return dict.copyState;
};
var containerSet = function (dictOrd) {
    var monoidSet = Data_Set_Serialized.monoidSet(dictOrd);
    return {
        fromArray: (function () {
            var $1003 = fromFoldable(dictOrd);
            return function ($1004) {
                return wrap($1003($1004));
            };
        })(),
        toArray: function ($1005) {
            return toUnfoldable(unwrap($1005));
        },
        Monoid0: function () {
            return monoidSet;
        }
    };
};
var containerArray = {
    fromArray: identity,
    toArray: identity,
    Monoid0: function () {
        return Data_Monoid.monoidArray;
    }
};
var bindFormDefM = Specular_FRP_Host.bindHost;
var bind3 = /* #__PURE__ */ Control_Bind.bind(bindFormDefM);
var discard3 = /* #__PURE__ */ discard(bindFormDefM);
var makeWithEffectInitializer = function (dictInitialize) {
    var makeImpl1 = makeImpl(dictInitialize);
    return function (p) {
        return function (opts) {
            return bind2(makeImpl1(p)(opts))(function (v) {
                return pure4({
                    field: v.field,
                    init: function (iv) {
                        return function (v1) {
                            return bind3(v1)(function (initializer$prime) {
                                return v.init(iv)(initializer$prime);
                            });
                        };
                    }
                });
            });
        };
    };
};
var initializeEffectInitializ = function (dictInitialize) {
    return {
        makeImpl: makeWithEffectInitializer(dictInitialize)
    };
};
var initializeNoInitialValueT = function (dictInitialize) {
    var makeImpl1 = makeImpl(dictInitialize);
    return function (dictInitialize1) {
        var makeImpl2 = makeImpl(dictInitialize1);
        return {
            makeImpl: function (v) {
                return function (opts) {
                    return bind2(makeImpl1(Type_Proxy["Proxy"].value)({
                        name: append(opts.name)([ "_0" ])
                    }))(function (v1) {
                        return bind2(makeImpl2(Type_Proxy["Proxy"].value)({
                            name: append(opts.name)([ "_1" ])
                        }))(function (v2) {
                            return pure4({
                                field: new Data_Tuple_T2.T2(v1.field, v2.field),
                                init: function (v3) {
                                    return function (v4) {
                                        return discard3(v1.init(NoInitialValue.value)(v4.value0))(function () {
                                            return v2.init(NoInitialValue.value)(v4.value1);
                                        });
                                    };
                                }
                            });
                        });
                    });
                };
            }
        };
    };
};
var initializeRecordCons = function (dictIsSymbol) {
    var reflectSymbol = Data_Symbol.reflectSymbol(dictIsSymbol);
    var insert1 = insert(dictIsSymbol);
    return function (dictInitializeRecord) {
        var makeRecordImpl1 = makeRecordImpl(dictInitializeRecord);
        return function (dictMaybeGetInitialValue) {
            var maybeGetInitialValue2 = maybeGetInitialValue(dictMaybeGetInitialValue);
            return function (dictMaybeGetInitializer) {
                var maybeGetInitializer2 = maybeGetInitializer(dictMaybeGetInitializer);
                return function (dictInitialize) {
                    var makeImpl1 = makeImpl(dictInitialize);
                    return function () {
                        return function () {
                            return {
                                makeRecordImpl: function (p) {
                                    return function (v) {
                                        return function (opts) {
                                            return bind2(makeImpl1(Type_Proxy["Proxy"].value)({
                                                name: append(opts.name)([ reflectSymbol(Type_Proxy["Proxy"].value) ])
                                            }))(function (x) {
                                                return bind2(makeRecordImpl1(p)(Type_Proxy["Proxy"].value)(opts))(function (xs) {
                                                    return pure4({
                                                        field: composeFlipped(xs.field)(insert1(Type_Proxy["Proxy"].value)(x.field)),
                                                        init: function (ivs) {
                                                            return function (is) {
                                                                return discard3(x.init(maybeGetInitialValue2(Type_Proxy["Proxy"].value)(ivs))(maybeGetInitializer2(Type_Proxy["Proxy"].value)(is)))(function () {
                                                                    return xs.init(ivs)(is);
                                                                });
                                                            };
                                                        }
                                                    });
                                                });
                                            });
                                        };
                                    };
                                }
                            };
                        };
                    };
                };
            };
        };
    };
};
var initializeSomeInitialValu1 = function (dictInitialize) {
    var makeImpl1 = makeImpl(dictInitialize);
    return function (dictInitialize1) {
        var makeImpl2 = makeImpl(dictInitialize1);
        return {
            makeImpl: function (v) {
                return function (opts) {
                    return bind2(makeImpl1(Type_Proxy["Proxy"].value)({
                        name: append(opts.name)([ "_0" ])
                    }))(function (v1) {
                        return bind2(makeImpl2(Type_Proxy["Proxy"].value)({
                            name: append(opts.name)([ "_1" ])
                        }))(function (v2) {
                            return pure4({
                                field: new Data_Tuple_T2.T2(v1.field, v2.field),
                                init: function (v3) {
                                    return function (v4) {
                                        return discard3(v1.init(new SomeInitialValue(v3.value0.value0))(v4.value0))(function () {
                                            return v2.init(new SomeInitialValue(v3.value0.value1))(v4.value1);
                                        });
                                    };
                                }
                            });
                        });
                    });
                };
            }
        };
    };
};
var asRecordRecord = {
    fromRecord: identity,
    toRecord: identity
};
var asRecordNewtype = function () {
    return {
        fromRecord: wrap,
        toRecord: unwrap
    };
};
var applyFormDefM = Specular_FRP_Host.applyHost;
var lift21 = /* #__PURE__ */ Control_Apply.lift2(applyFormDefM);
var semigroupFormDefM = function (dictSemigroup) {
    return {
        append: lift21(Data_Semigroup.append(dictSemigroup))
    };
};
var applicativeFormDefM = Specular_FRP_Host.applicativeHost;
var pure5 = /* #__PURE__ */ Control_Applicative.pure(applicativeFormDefM);
var monoidFormDefM = function (dictMonoid) {
    var semigroupFormDefM1 = semigroupFormDefM(dictMonoid.Semigroup0());
    return {
        mempty: pure5(Data_Monoid.mempty(dictMonoid)),
        Semigroup0: function () {
            return semigroupFormDefM1;
        }
    };
};
var initializeRecordNil = {
    makeRecordImpl: function (v) {
        return function (v1) {
            return function (v2) {
                return pure4({
                    field: identity1,
                    init: function (v3) {
                        return function (v4) {
                            return pure5(Data_Unit.unit);
                        };
                    }
                });
            };
        };
    }
};
var annotatedFinal = function (name) {
    var $1006 = Specular_FRP_Base.annotated(name);
    return function ($1007) {
        return Restaumatic_Form_Final.makeFinalV($1006(Restaumatic_Form_Final.unFinalV($1007)));
    };
};
var annotateFinal = function (dictMonadEffect) {
    var $1008 = Specular_FRP_Base.annotate(dictMonadEffect);
    return function ($1009) {
        return $1008(Restaumatic_Form_Final.unFinal($1009));
    };
};
var afterInitialized = function (eff) {
    return bind3(liftEffect(Effect_Ref["new"](pure(Data_Unit.unit))))(function (unsubRef) {
        return discard3(onCleanup(function __do() {
            var unsub = Effect_Ref.read(unsubRef)();
            Effect_Ref.write(pure(Data_Unit.unit))(unsubRef)();
            return unsub();
        }))(function () {
            return liftEffect(Specular_Extra_Async.nextMicrotask(function __do() {
                var v = Specular_FRP_Host.runHost(eff)();
                return Effect_Ref.write(v.value1)(unsubRef)();
            }));
        });
    });
};
var addMetadataRecord = function (dict) {
    return dict.addMetadataRecord;
};
var addMetadataRecordRecordRe = function () {
    return function () {
        return function () {
            return function () {
                return function (dictAddMetadataRecord) {
                    var addMetadataRecord1 = addMetadataRecord(dictAddMetadataRecord);
                    return {
                        addMetadata: function (m) {
                            return function (rec) {
                                return addMetadataRecord1(Type_Proxy["Proxy"].value)(rowListIntersection(m)(rec))(rec);
                            };
                        }
                    };
                };
            };
        };
    };
};
var addMetadata = function (dict) {
    return dict.addMetadata;
};
var makeWithMetadataInitializer = function (dictInitialize) {
    var makeImpl1 = makeImpl(dictInitialize);
    return function (dictAddMetadata) {
        var addMetadata1 = addMetadata(dictAddMetadata);
        return function (p) {
            return function (opts) {
                return bind2(makeImpl1(p)(opts))(function (v) {
                    return pure4({
                        field: v.field,
                        init: function (iv) {
                            return function (v1) {
                                return v.init(iv)(addMetadata1(v1.value0)(v1.value1));
                            };
                        }
                    });
                });
            };
        };
    };
};
var initializeMetadataInitial = function (dictAddMetadata) {
    return function (dictInitialize) {
        return {
            makeImpl: makeWithMetadataInitializer(dictInitialize)(dictAddMetadata)
        };
    };
};
var addMetadataContextInitial = function (dictAddMetadata) {
    var addMetadata1 = addMetadata(dictAddMetadata);
    return {
        addMetadata: function (m) {
            return function (v) {
                return new ContextInitializer(v.value0, addMetadata1(m)(v.value1));
            };
        }
    };
};
var addMetadataEffectInitiali = function (dictAddMetadata) {
    var addMetadata1 = addMetadata(dictAddMetadata);
    return {
        addMetadata: function (m) {
            return function (v) {
                return map4(addMetadata1(m))(v);
            };
        }
    };
};
var addMetadataFunctionFuncti = function (dictAddMetadata) {
    var addMetadata1 = addMetadata(dictAddMetadata);
    return {
        addMetadata: function (m) {
            return function (f) {
                return function (a) {
                    return addMetadata1(m)(f(a));
                };
            };
        }
    };
};
var addMetadataInitialValueIn = function (dictAddMetadata) {
    var addMetadata1 = addMetadata(dictAddMetadata);
    return {
        addMetadata: function (m) {
            return function (v) {
                return new InitialValueInitializer(v.value0, addMetadata1(m)(v.value1));
            };
        }
    };
};
var addMetadataRecordCons = function (dictIsSymbol) {
    var delete1 = Record["delete"](dictIsSymbol)()();
    var get = Record.get(dictIsSymbol)();
    var insert1 = Record.insert(dictIsSymbol)()();
    return function (dictAddMetadataRecord) {
        var addMetadataRecord1 = addMetadataRecord(dictAddMetadataRecord);
        return function (dictAddMetadata) {
            var addMetadata1 = addMetadata(dictAddMetadata);
            return function () {
                return function () {
                    return function () {
                        return function () {
                            return function () {
                                return {
                                    addMetadataRecord: function (v) {
                                        return function (meta) {
                                            return function (is) {
                                                var rest = addMetadataRecord1(Type_Proxy["Proxy"].value)(meta)(delete1(Type_Proxy["Proxy"].value)(is));
                                                var val = addMetadata1(get(Type_Proxy["Proxy"].value)(meta))(get(Type_Proxy["Proxy"].value)(is));
                                                return insert1(Type_Proxy["Proxy"].value)(val)(rest);
                                            };
                                        };
                                    }
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
var addErrorsRecord = function (dict) {
    return dict.addErrorsRecord;
};
var addErrorsRecord1 = function () {
    return function (dictAddErrorsRecord) {
        var addErrorsRecord2 = addErrorsRecord(dictAddErrorsRecord);
        return {
            addErrors: function (errors) {
                return addErrorsRecord2(errors)(Type_Proxy["Proxy"].value);
            }
        };
    };
};
var addErrors = function (dict) {
    return dict.addErrors;
};
var addErrorsPrefix = function (dictAddErrors) {
    var addErrors1 = addErrors(dictAddErrors);
    return function (prefix) {
        return function (errors) {
            return function (f) {
                var addPrefix = function (v) {
                    return new Data_Tuple.Tuple(prefix + ("." + v.value0), v.value1);
                };
                var prefixedErrors = fromFoldable1(map2(addPrefix)(toUnfoldable1(errors)));
                return addErrors1(prefixedErrors)(f);
            };
        };
    };
};
var addErrorsRecordCons = function (dictIsSymbol) {
    var get = Record.get(dictIsSymbol)();
    return function (dictAddErrorsRecord) {
        var addErrorsRecord2 = addErrorsRecord(dictAddErrorsRecord);
        return function (dictAddErrors) {
            var addErrors1 = addErrors(dictAddErrors);
            return function () {
                return function () {
                    return {
                        addErrorsRecord: function (errors) {
                            return function (v) {
                                return function (f) {
                                    return function __do() {
                                        addErrors1(errors)(get(Type_Proxy["Proxy"].value)(f))();
                                        return addErrorsRecord2(errors)(Type_Proxy["Proxy"].value)(f)();
                                    };
                                };
                            };
                        }
                    };
                };
            };
        };
    };
};
var addContextRecordNil = {
    addContextRecord: function (v) {
        return function (v1) {
            return function (v2) {
                return pure(Data_Unit.unit);
            };
        };
    }
};
var addContextRecord = function (dict) {
    return dict.addContextRecord;
};
var addContext_Record = function () {
    return function (dictAddContextRecord) {
        return {
            addContext: addContextRecord(dictAddContextRecord)(Type_Proxy["Proxy"].value)
        };
    };
};
var addContextMaybe = {
    addContext: function (v) {
        return function (v1) {
            return pure(Data_Unit.unit);
        };
    }
};
var addContext = function (dict) {
    return dict.addContext;
};
var addContextRecordCons = function (dictIsSymbol) {
    var get = Record.get(dictIsSymbol)();
    return function (dictAddContextRecord) {
        var addContextRecord1 = addContextRecord(dictAddContextRecord);
        return function (dictAddContext) {
            var addContext1 = addContext(dictAddContext);
            return function () {
                return function () {
                    return {
                        addContextRecord: function (v) {
                            return function (ctx) {
                                return function (f) {
                                    return function __do() {
                                        addContext1(ctx)(get(Type_Proxy["Proxy"].value)(f))();
                                        return addContextRecord1(Type_Proxy["Proxy"].value)(ctx)(f)();
                                    };
                                };
                            };
                        }
                    };
                };
            };
        };
    };
};
var makeWithContextInitializer = function (dictInitialize) {
    var makeImpl1 = makeImpl(dictInitialize);
    return function (dictAddContext) {
        var addContext1 = addContext(dictAddContext);
        return function (p) {
            return function (opts) {
                return bind2(makeImpl1(p)(opts))(function (v) {
                    return pure4({
                        field: v.field,
                        init: function (iv) {
                            return function (v1) {
                                return discard3(liftEffect(addContext1(v1.value0)(v.field)))(function () {
                                    return v.init(iv)(v1.value1);
                                });
                            };
                        }
                    });
                });
            };
        };
    };
};
var initializeContextInitiali = function (dictAddContext) {
    return function (dictInitialize) {
        return {
            makeImpl: makeWithContextInitializer(dictInitialize)(dictAddContext)
        };
    };
};
var addContextT2 = function (dictAddContext) {
    var addContext1 = addContext(dictAddContext);
    return function (dictAddContext1) {
        var addContext2 = addContext(dictAddContext1);
        return {
            addContext: function (ctx) {
                return function (v) {
                    return function __do() {
                        addContext1(ctx)(v.value0)();
                        return addContext2(ctx)(v.value1)();
                    };
                };
            }
        };
    };
};
export {
    addContext,
    addContextRecord,
    addErrors,
    addErrorsRecord,
    addMetadata,
    addMetadataRecord,
    copyState,
    displayedErrors,
    dumpState,
    dumpStateRecord,
    fromArray,
    fromRecord,
    getContext,
    getFieldId,
    getLabel,
    mSelectGetOptions,
    mSelectReadValue,
    mSelectTouch,
    mSelectWriteValue,
    makeImpl,
    makeRecordImpl,
    makeWithInitialValueInitializer,
    maybeGetInitialValue,
    maybeGetInitialValue$prime,
    maybeGetInitializer,
    maybeGetInitializer$prime,
    merge,
    mergeInputRequired,
    mergeRecord,
    readRefLike,
    selectGetOptions,
    selectReadValue,
    selectTouch,
    selectWriteValue,
    textInput,
    toArray,
    toRecord,
    touchRefLike,
    writeRefLike,
    Undefined,
    Invalid,
    Valid,
    requiredError,
    fieldPathToString,
    hasDisplayedErrors,
    addErrorsPrefix,
    NoInitialValue,
    SomeInitialValue,
    NoInitializer,
    make,
    runFormDefM,
    InitialValueInitializer,
    withInitialValue,
    ContextInitializer,
    withContext,
    makeWithContextInitializer,
    EffectInitializer,
    withEffect,
    makeWithEffectInitializer,
    makeWithDefaultInitializer,
    initializerFor,
    Metadata,
    MetadataInitializer,
    withMetadata,
    makeWithMetadataInitializer,
    write,
    unFinalWithDefault,
    annotateFinal,
    annotatedFinal,
    mapMaybeFinal,
    mapMaybeFinalUserVisible,
    mapMaybeFinalInternal,
    mapVFinal,
    mapDynamicFinal,
    withFinal_,
    liftMaybe,
    tagErrors,
    dynamicFromContext,
    unFinalFromContext,
    dynamicFromContextDef,
    unFinalFromContextDef,
    FormDefM,
    afterInitialized,
    nonEmpty,
    shorterThan,
    validateTrue,
    validateJust,
    validateJustIf,
    greaterThan,
    greaterThanOrEqual,
    greaterThanOrEqualFmt,
    lessThan,
    lessThanOrEqual,
    validateWhenJust,
    validateWhenValueJust,
    failFirst,
    writeRef,
    MappedField,
    optionForEq,
    RefWithOptions,
    modifyRefLike,
    fromChoices,
    WithOptions,
    withOptions,
    maybeContainerToArray,
    selectInput,
    singleOption,
    withNothing,
    displayLocale,
    displayLocaleKey,
    forceDisplayErrorsKey,
    forceDisplayErrors,
    WithId,
    withId,
    genericTypedValue,
    showTypedValue,
    encodeTypedValue,
    hasErrorsOldFormField,
    hasErrorsErrorArray,
    hasErrorsMappedField,
    hasErrorsWithId,
    hasErrorsWithOptions,
    hasErrorsRef,
    hasErrorsChoiceRef,
    hasErrorsDelayed,
    addErrorsRecord1,
    addErrorsRecordNil,
    addErrorsRecordCons,
    dumpState_Record,
    dumpStateRecordNil,
    dumpStateRecordCons,
    initializeNoInitialValueT,
    initializeSomeInitialValu1,
    initializeNoInitialValueR,
    initializeSomeInitialValu,
    initializeRecordNil,
    maybeGetInitialValue1,
    maybeGetInitialValue$primeTrue,
    maybeGetInitialValue$primeFals,
    maybeGetInitializer1,
    maybeGetInitializer$primeTrue,
    maybeGetInitializer$primeFalse,
    initializeRecordCons,
    makeWithInitialValueIniti,
    makeWithInitialValueIniti1,
    initializeInitialValueIni,
    initializeContextInitiali,
    initializeEffectInitializ,
    initializeNoInitializerRe,
    initializeMetadataInitial,
    addMetadataInitialValueIn,
    addMetadataContextInitial,
    addMetadataEffectInitiali,
    addMetadataMetadataRecord,
    addMetadataMetadataNoInit,
    addMetadataFinalStringRec,
    addMetadataFinalStringNoI,
    addMetadataEffectEffect,
    addMetadataDynamicDynamic,
    addMetadataFunctionFuncti,
    addMetadataRecordRecordRe,
    addMetadataRecordNil,
    addMetadataRecordCons,
    asRecordRecord,
    asRecordNewtype,
    mergeRef,
    mergeChoiceRef,
    mergeDelayed,
    mergeT2T2,
    mergeUnit,
    merge_Record,
    mergeRecordNil,
    mergeRecordCons,
    addContextFormField,
    addContextRef,
    addContextEffect,
    addContextDynamic,
    addContextT2,
    addContextMaybe,
    addContext_Record,
    addContextRecordNil,
    addContextRecordCons,
    hasContextContext,
    hasContextRefContext,
    hasContextWithId,
    hasContextDelayed,
    functorFormDefM,
    applyFormDefM,
    applicativeFormDefM,
    bindFormDefM,
    monadFormDefM,
    monadEffectFormDefM,
    monadCleanupFormDefM,
    semigroupFormDefM,
    monoidFormDefM,
    hasLabelMappedField,
    isTextFieldRefString,
    isTextFieldFormFieldStrin,
    isTextFieldWithId,
    hasLabelWithId,
    hasOptionsArray,
    hasOptionsSet,
    hasOptionsSMultiSet,
    hasOptionsSingle,
    isSelectFieldWithId,
    isRefLikeRef,
    isRefLikeFormField,
    hasLabelRef,
    hasLabelFormField,
    hasLabelRefWithOptions,
    hasErrorsRefWithOptions,
    isRefLikeWithId,
    hasFieldIdRefWithOptions,
    hasFieldIdWithOptions,
    isSelectFieldRefWithOptions,
    isSelectFieldChoiceRef,
    containerArray,
    containerSet,
    isMultiSelectFieldMultiChoiceRef,
    isMultiSelectFieldRefWith,
    isMultiSelectFieldWithId,
    hasFieldIdString,
    hasFieldIdFormField,
    hasFieldIdChoiceRef,
    hasFieldIdRef,
    hasFieldIdFunctionEffect,
    hasFieldIdEffect,
    hasFieldIdWithId
};
